export const useMainSectionFallbackBackground = () =>
    'https://avatars.mds.yandex.net/get-ott/12808873/2a0000019a96095f450c982d2bd0bab716fe/orig';
